import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

function sliderOrderStart(): void {
  const orderStartSlider = document.querySelector<HTMLElement>(".js-order-start-slider");
  if (!orderStartSlider) return;

  const splide = new Splide(orderStartSlider, {
    type: "loop",
    drag: false,
    arrows: false,
    pagination: false,
    perPage: 3,
    gap: 40,
    autoWidth: true,
    focus: "center",
    trimSpace: false,
    autoScroll: {
      speed: -0.5,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount({ AutoScroll });
}

export { sliderOrderStart };
